import { useEffect, useState } from 'react';
import { doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import { SITE_CONTENT_DEFAULTS } from '../data/siteContentDefaults';

export const useSiteContent = (sectionKey) => {
  const fallback = SITE_CONTENT_DEFAULTS[sectionKey];
  const [content, setContent] = useState(fallback);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sectionKey) return undefined;

    const docRef = doc(db, 'site_content', sectionKey);
    const unsubscribe = onSnapshot(
      docRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const docData = snapshot.data();
          setContent(docData.content ?? fallback);
        } else {
          setContent(fallback);
        }
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error('Erreur chargement contenu dynamique:', err);
        if (err.code === 'permission-denied') {
          setError("Acces refuse a la collection site_content. Verifiez les regles Firestore.");
        } else {
          setError(err.message);
        }
        setContent(fallback);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [sectionKey, fallback]);

  return { content, loading, error };
};

export const saveSiteContent = async (sectionKey, content) => {
  if (!sectionKey) {
    return { success: false, error: 'Section invalide.' };
  }

  try {
    const docRef = doc(db, 'site_content', sectionKey);
    await setDoc(
      docRef,
      {
        content,
        updatedAt: serverTimestamp()
      },
      { merge: true }
    );
    return { success: true };
  } catch (err) {
    console.error('Erreur sauvegarde contenu dynamique:', err);
    if (err.code === 'permission-denied') {
      return { success: false, error: "Acces refuse a la collection site_content. Verifiez les regles Firestore." };
    }
    return { success: false, error: err.message };
  }
};
